import React from 'react';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';

import BaseRouteHandler from '../../Routes/components/common/routeHandlers/BaseRouteHandler';

const ArchivedVendorsPageCodeSplit = lazyForPaint(() =>
  import(
    /* webpackPrefetch: true, webpackChunkName: "chunk-archivedVendorsPage" */ './ArchivedVendorsPage'
  ).then((module) => module.default)
);

const ArchivedVendorsRouteHandler = () => {
  return (
    <BaseRouteHandler>
      <LazySuspense fallback={<div>Loading...</div>}>
        <ArchivedVendorsPageCodeSplit />
      </LazySuspense>
    </BaseRouteHandler>
  );
};

export default ArchivedVendorsRouteHandler;
